import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

import { UiPalette } from '../../../types/UiPalette.type';
import { UiAdminModule } from '../../../ui.module';
import { IconBadgeComponent } from '../../molecules/icon-badge/icon-badge.component';

@Component({
  standalone: true,
  selector: 'eiq-section-card',
  templateUrl: 'section-card.component.html',
  styleUrls: ['./section-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconBadgeComponent, UiAdminModule]
})
export class SectionCardComponent {
  position = input.required<number>();
  title = input.required<string>();
  subtitle = input<string>('');
  icon = input.required<IconDefinition>();
  color = input<UiPalette>('accent');
  valid = input<boolean>(false);
  sectionId = input<string>('');

  heading$ = computed(() => `${this.position()}. ${this.title()}`);

  faCircleCheck = faCircleCheck;
}
